const functions = {
    /**
     * Get the lang in url (en/pt-br/etc)
     */
    getLangInUrl: () => {
        var url = window.location.href;
        var res = url.split("/");
        return res[res.length - 2]
    }
}

export default functions;